import { FC } from 'react'

import { Button } from 'ui/components/Buttons'
import { Hr } from 'ui/components/Hr'
import { Info, InfoSet, InfoSetDirection } from 'ui/components/Info'
import { Link } from 'ui/components/Link'
import { PageSectionPrimary } from 'ui/components/Page'

import { GeneralInformationProps } from './GeneralInformationProps'
import { AccountInformation, AddressInformation, RelationShipInformation } from './components'

export const GeneralInformation: FC<GeneralInformationProps> = (props) => {
  const { data } = props
  const { id, description, physicalAddress, mailingAddress } = data

  return (
    <PageSectionPrimary
      title="Company Information"
      anchor="general"
      actions={
        <Link to="/relationships/edit/$companyId" params={{ companyId: id.toString() }}>
          <Button face="primary">Edit</Button>
        </Link>
      }
      face="outlined"
    >
      <RelationShipInformation data={data} />
      <Hr />
      <InfoSet direction={InfoSetDirection.ROW} legend="Description">
        <Info>{description}</Info>
      </InfoSet>
      <Hr />
      <AccountInformation data={data} />
      <Hr />
      <AddressInformation physicalAddress={physicalAddress} mailingAddress={mailingAddress} />
    </PageSectionPrimary>
  )
}
